import { gql } from '@apollo/client';

const SEND_FEEDBACK_EMAIL_MUTATION = gql`
  mutation sendFeedbackEmail($input: SupportEmailInput!) {
    sendFeedbackEmail(input: $input) {
      isSuccess
      message
    }
  }
`;

export default SEND_FEEDBACK_EMAIL_MUTATION;
